import styled from '../../../../theme/styled-with-theme';
import { Flexbox } from '../../../Flexbox';
import { pxToRem } from 'src/styles/utils';
import { Layout } from '../../../Layout';

export const CtaWrapper = styled(Flexbox)`
  width: 100%;
`;

export const SidebarLayout = styled(Layout)`
  border-radius: ${pxToRem(24)};
  background: #fff;
  margin: 0 !important;
`;
